// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"ratingTrend__gradient-bg5__j9_FB","ratingTrend":"ratingTrend__ratingTrend__fE_zt"};